<div class="footer">
  <div class="footer__inner">
    <section class="footer__section footer__section--logo">
      <h3 class="footer__section-title">{{ footer.socialTitle }}</h3>
      <ul class="footer__icon-links" [attr.aria-label]="'Footer.SocialMediaLinks' | translate">
        @for (link of footer.socialLinks; track link) {
          <li [paiCmsId]="link">
            <a
              [href]="link.url"
              [paiIconButton]="link.icon && link.icon.url ? link.icon.url : ''"
              size="small"
              appearance="primary"
              [attr.aria-label]="link.label"
              [title]="link.label"
            ></a>
          </li>
        }
      </ul>
    </section>

    <section class="footer__section">
      <h3 class="footer__section-title">{{ footer.contactTitle }}</h3>
      <div [paiLexicalRichText]="footer.contactAddress"></div>
    </section>

    <section class="footer__section">
      <h3 class="footer__section-title" id="pai-footer-sitemap-title">{{ footer.sitemapTitle }}</h3>
      <ul class="footer__links" aria-describedby="pai-footer-sitemap-title">
        @for (item of footer.sitemapItems; track item.id) {
          <li [paiCmsId]="item">
            <a
              class="footer__link-item"
              [href]="item.url"
              target="_blank"
              [attr.hreflang]="item.targetSiteLanguage === '_' ? null : item.targetSiteLanguage"
              >{{ item.label }}</a
            >
          </li>
        }
      </ul>
    </section>

    <section class="footer__section footer__section--subscribe">
      <h3 class="footer__section-title">{{ footer.subscribeTitle }}</h3>
      <pai-newsletter-subscription />
    </section>

    <section class="footer__section footer__section--bottom">
      <div class="footer__copyright">{{ footer.copyright }}</div>

      <ul class="footer__links-row">
        @for (item of footer.bottomLineLinks; track item.id) {
          <li [paiCmsId]="item">
            <a class="footer__row-link" [paiCmsLink]="item.target">{{ item.label }}</a>
          </li>
        }
      </ul>

      @if (languages$ | async; as languages) {
        <ul class="footer__lang-selection" [attr.aria-label]="'Footer.LanguageList' | translate">
          <pai-icon class="footer__lang-selection-icon" icon="globe-2" aria-hidden="true" />
          @for (lang of languages; track lang.id) {
            <li [paiCmsId]="lang">
              <a
                class="footer__lang-selection-link"
                [class.footer__lang-selection-link--selected]="lang.selected"
                [attr.title]="lang.label"
                [lang]="lang.abbr"
                [attr.aria-label]="lang.label"
                [attr.hreflang]="lang.abbr"
                [attr.href]="lang.altUrl"
                >{{ lang.abbr | uppercase }}</a
              >
            </li>
          }
        </ul>
      }
    </section>
  </div>
</div>
